import { Button } from 'react-bootstrap';

const WorkoutForm = ({ formFields, onChange }) => {
  const updateFields = (updater) => onChange((current) => updater(current));

  const handleInputChange = (index, event) => {
    updateFields((current) => current.map((field, fieldIndex) => (
      fieldIndex === index ? { ...field, [event.target.name]: event.target.value } : field
    )));
  };

  const handleAddField = () => {
    updateFields((current) => [...current, { series: '', peso: '', repeticiones: '' }]);
  };

  const handleRemoveField = (index) => {
    updateFields((current) => current.filter((_, fieldIndex) => fieldIndex !== index));
  };

  return (
    <div className="workout-form">
      {formFields.map((field, index) => (
        <div className="form-row" key={index}>
          <input
            type="number"
            name="series"
            value={field.series}
            onChange={(event) => handleInputChange(index, event)}
            className="form-input"
            placeholder="Series"
            required
          />
          <input
            type="number"
            name="peso"
            value={field.peso}
            onChange={(event) => handleInputChange(index, event)}
            className="form-input"
            placeholder="Peso"
            required
          />
          <input
            type="number"
            name="repeticiones"
            value={field.repeticiones}
            onChange={(event) => handleInputChange(index, event)}
            className="form-input"
            placeholder="Repeticiones"
            required
          />
          {formFields.length > 1 && (
            <button type="button" onClick={() => handleRemoveField(index)}>Eliminar</button>
          )}
        </div>
      ))}
      <br />
      <div className="button-row" >
        <Button type="button" onClick={handleAddField}>Agregar otra serie</Button>
      
      </div>
      <br />
    </div>
  );
}

export default WorkoutForm;
